import { render } from "./NewRawMaterialModal.vue?vue&type=template&id=07cb567f&ts=true"
import script from "./NewRawMaterialModal.vue?vue&type=script&lang=ts"
export * from "./NewRawMaterialModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__